import React from 'react';
import { GameBasicInfo } from './GameBasicInfo';
import { GameTags } from './GameTags';
import { PayoutInfo } from './PayoutInfo';
import { GamingSystems } from './GamingSystems';

export const GameDetailsContent = ({ game, selectedGame, matchedGameData, singleGameData }) => {
    if (singleGameData) {
        const relevantPayoutVariant = game?.payoutVariants?.find(
            variant => variant.payoutVariantName === selectedGame?.game?.launchID
        );

        return (
            <div className="details-section">
                <GameBasicInfo gameData={selectedGame} isSingleGame={true} />
                <GameTags gameTags={game?.gameTags} studio={game?.studio} />
                <PayoutInfo payoutData={relevantPayoutVariant} />
                <GamingSystems systems={game?.gamingSystems} />
            </div>
        );
    }

    return (
        <div className="details-section">
            <GameBasicInfo gameData={game} isSingleGame={false} />
            {matchedGameData && (
                <>
                    <GameTags gameTags={matchedGameData.gameTags} studio={matchedGameData.studio} />
                    <PayoutInfo payoutData={{ mathModel: { payoutPercentage: matchedGameData.mathModel } }} />
                    <GamingSystems systems={matchedGameData.gamingSystems} />
                </>
            )}
        </div>
    );
};
